import { Topic } from '@coin/shared/core/util-models';

export class LoadTopics {
  static readonly type = '[Topics] Load Topics';
}
export class LoadTopicsSuccess {
  static readonly type = '[Topics] Load Topics Success';
  constructor(public readonly payload: Topic[]) {}
}
export class LoadTopicsFail {
  static readonly type = '[Topics] Load Topics Fail';
  constructor(public readonly payload?: unknown) {}
}

export class UpdateBannerVisibility {
  static readonly type = '[Topics] Update Banner Visibility';
  constructor(public readonly payload: Topic) {}
}

export class ExtractCategories {
  static readonly type = '[Categories] Extract Categories';
}

export type TopicsActions = LoadTopics | LoadTopicsSuccess | LoadTopicsFail | ExtractCategories;
